import React from 'react';
import './style.scss';

export default ColumnHeaders = () => {

    const columns = [
        {title: 'Date', width: 1, color: 'white'},
        {title: 'Purchase', width: 1, color: 'white'},
        {title: 'Customer Email', width: 2, color: 'white'},
        {title: 'Origin Source', width: 3, color: 'white'},
        // {title: 'Last Source', width: 3, color: 'black'},
        {title: 'Customer Journey', width: 2, color: 'black'},
    ]

    const columnDisplay = columns.length ? (
        columns.map((col, i) => {
            
            return (
                <div key={i} className={`headers-col ${col.width === 2 ? 'wide-2' : col.width === 3 ? 'wide-3' : ''} ${col.title === 'Customer Journey' ? 'centered-col' : ''}  ${col.title === 'Customer Email' ? 'cust-email' : ''}`}>
                    <h2 className={`headers-font inline-headers ${col.color === 'white' ? 'headers-white' : col.color === 'black' ? 'headers-black' : ''}`}>
                        {col.title}
                    </h2>
                </div>
            )
        })

    ) : []

    return (
        <div className={`headers-main`}>
            {columnDisplay}
        </div>
    )
}